import { cva } from 'class-variance-authority'

// `leftOffset`/`rightOffset` apply at every breakpoint, including mobile:
// a fixed overlay a caller needs to clear (e.g. Haven's chat trigger) can
// easily still be present on small screens, so this component doesn't
// assume otherwise. If a caller's offset genuinely doesn't apply on
// mobile (e.g. a sidebar that collapses there), that's on the caller to
// vary, the same way `leftOffset` already worked before `rightOffset`
// existed.
export const styles = cva(
  `
  bottom-0
  z-10
  flex
  items-center
  justify-end
  gap-2
  border-t
  border-neutral-200
  bg-neutral-0
  py-6
  px-0
  max-sm:flex-col-reverse
  max-sm:gap-3
  max-sm:px-4
  max-sm:py-6
  max-sm:[&>*]:w-full
`,
  {
    variants: {
      // Written mobile-first rather than as a `max-sm:` override: two position utilities at
      // equal specificity are decided by source order, and only the min-width form is
      // guaranteed to be emitted after the base one.
      // `w-full` because in the flow the bar is sized by its parent, and an `items-center`
      // column would otherwise shrink it to its buttons. Released again once fixed, where
      // `left`/`right` size it instead.
      unfixedOnMobile: {
        true: 'static w-full sm:fixed sm:w-auto',
        false: 'fixed',
      },
    },
    defaultVariants: { unfixedOnMobile: false },
  }
)

export const actionsStyles = cva(`
  flex
  items-center
  gap-2

  max-sm:w-full
  max-sm:flex-col-reverse
  max-sm:gap-3
  max-sm:[&>*]:w-full
`)
